
































import Vue from "vue";
import {
  ResponseListItem,
  ResponseModalI,
  VueConstructor,
  Game
} from "vue/types/vue";
import { PuzzleData } from "../../services/vo";
import PuzzleGrid from "@/components/PlayArea/PuzzleGrid.vue";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      game: Game;
    };
  }
>).extend({
  name: "ResponseModal",
  components: {
    PuzzleGrid
  },
  data() {
    return {
      response: {} as ResponseListItem,
      puzzleData: [] as PuzzleData[],
      refresh: 1
    };
  },
  created() {
    this.response = this.emptyResponse;
    this.puzzleData = [] as PuzzleData[];
  },
  computed: {
    emptyResponse: function(): ResponseListItem {
      let empty: ResponseListItem = {} as ResponseListItem;

      empty.submittedby = "";
      empty.submitted = "";
      empty.response = "";

      return empty;
    },
    getResponse: function(): string[] {
      if (this.response.response === "") return [];
      else {
        return this.response.response.split("");
      }
    }
  },
  methods: {
    setResponse: function(response: ResponseListItem): void {
      if (response !== this.response) {
        this.refresh = Math.random();
        this.response = response;

        this.$refs.game.toggleSolution(this.response.response.split(""));
      }
    },
    setPuzzle: function(puzzle: PuzzleData[]): void {
      this.puzzleData = puzzle;
    },
    close: function(): void {
      this.$emit("close");
    }
  },
  watch: {
    response: function() {
      //  console.log("RESP WATCH");
      //  this.refresh = Math.random();
    }
  }
});
